import React from 'react'
import { Form, Input  } from 'antd';

const CompanyInput = () => {
  return (
    <Form.Item
    style={{margin:0}}
    label="Nazwa firmy"
    name="title"
    rules={[
    {
        // required: true,
        // message: 'Please input company name!',
    },
    ]}
>
    <Input style={{marginLeft: '10px'}}/>
</Form.Item>
  )
}

export default CompanyInput